import React from "react";

interface Position {
  symbol?: string;
  marketId?: string;
  market_id?: string;
  size?: number;
  entryPrice?: number;
  entry_price?: number;
  markPrice?: number;
  mark_price?: number;
  liquidationPrice?: number;
  liquidation_price?: number;
  unrealizedPnL?: number;
  unrealized_pnl?: number;
  pnl?: number;
  leverage?: number;
  margin?: number;
  marginMode?: string;
  margin_mode?: string;
}

interface PositionsDisplayProps {
  positions: Position[];
}

export const PositionsDisplay: React.FC<PositionsDisplayProps> = ({
  positions,
}) => {
  if (!positions || positions.length === 0) {
    return null;
  }

  return (
    <div className="positions-container">
      <strong className="positions-title">Positions ({positions.length}):</strong>
      <div className="positions-grid">
        {positions.map((pos, idx) => {
          const size = pos.size || 0;
          const side = size >= 0 ? "LONG" : "SHORT";
          return (
            <div key={idx} className="position-card">
              <div className="position-symbol">
                {pos.symbol ||
                  `Market ${pos.marketId || pos.market_id || "N/A"}`}
              </div>
              <div className="position-details">
                <div>
                  <strong>Side:</strong>{" "}
                  <span
                    className={
                      side === "LONG"
                        ? "position-side-long"
                        : "position-side-short"
                    }
                  >
                    {side}
                  </span>
                </div>
                <div>
                  <strong>Size:</strong> {Math.abs(size).toFixed(8)}
                </div>
                {pos.entryPrice !== undefined ||
                pos.entry_price !== undefined ? (
                  <div>
                    <strong>Entry Price:</strong>{" "}
                    {(pos.entryPrice || pos.entry_price || 0).toFixed(8)}
                  </div>
                ) : null}
                {pos.markPrice !== undefined || pos.mark_price !== undefined ? (
                  <div>
                    <strong>Mark Price:</strong>{" "}
                    {(pos.markPrice || pos.mark_price || 0).toFixed(8)}
                  </div>
                ) : null}
                {pos.liquidationPrice !== undefined ||
                pos.liquidation_price !== undefined ? (
                  <div>
                    <strong>Liquidation Price:</strong>{" "}
                    {(pos.liquidationPrice || pos.liquidation_price || 0).toFixed(8)}
                  </div>
                ) : null}
                {pos.unrealizedPnL !== undefined ||
                pos.unrealized_pnl !== undefined ||
                pos.pnl !== undefined ? (
                  <div>
                    <strong>Unrealized PnL:</strong>{" "}
                    <span
                      className={
                        (pos.unrealizedPnL ||
                          pos.unrealized_pnl ||
                          pos.pnl ||
                          0) >= 0
                          ? "position-pnl-positive"
                          : "position-pnl-negative"
                      }
                    >
                      {(
                        pos.unrealizedPnL ||
                        pos.unrealized_pnl ||
                        pos.pnl ||
                        0
                      ).toFixed(8)}
                    </span>
                  </div>
                ) : null}
                {pos.leverage !== undefined ? (
                  <div>
                    <strong>Leverage:</strong> {pos.leverage}x
                  </div>
                ) : null}
                {pos.margin !== undefined ? (
                  <div>
                    <strong>Margin:</strong> {pos.margin.toFixed(8)}
                  </div>
                ) : null}
                {pos.marginMode !== undefined ||
                pos.margin_mode !== undefined ? (
                  <div>
                    <strong>Margin Mode:</strong>{" "}
                    {pos.marginMode || pos.margin_mode || "N/A"}
                  </div>
                ) : null}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

